module.exports = __webpack_public_path__ + "img/freewave2_02.22d91d8b.jpg";